/**
 * 弹窗
 * @param { title, imgICon, text, onClose, btn, imgWidth, textStyle, contertStyle}
 *  title String 弹窗名称
 *  imgICon 图片
 *  imgStyle 图片宽度 默认2.5rem
 *  textStyle 内容自定义样式
 *  text String 中间段落
 *  btn Array 按钮
 *    btn-item Object {name:'',callBack:fun}
 */
import ReactDOM from 'react-dom';
import React from 'react';
import { Icon } from 'antd-mobile';
import { appTell, isCsairApp } from '@csair/emp-helpers';
import Btn from 'Btn';
import urlConfig from 'Url';
import './index.less';
import { client } from '../../store/axiosMiddleware';
import { webEntry } from 'utilsRecommendCode';
import { session, getPageName } from 'Utils';

import cn from 'cn';
import en from 'en';

// 预约受理后缀标题
const fastRefundSufTitle = '选择机票退票预约受理业务。';
/**
 * 获取预约受理提示语，如果匹配得上，将再最后面补充 选择机票退票预约受理业务
 * @param {String} msg
 */
// function getFastRefundMsg(msg) {
//   // 是否需要修改文案，true = 是
//   let needMod = false;
//   if (msg) {
//     if (
//       msg.includes('企业订座客票暂不支持自助处理') ||
//       msg.includes(
//         '客票非直销渠道直接购买，一次只允许退一个成人旅客，退其他成人旅客请分开提交'
//       ) ||
//       msg.includes('客票状态不符') ||
//       msg.includes('请勾选所有可退航段') ||
//       msg.includes('为线下渠道出票，暂不支持自助处理')
//     ) {
//       needMod = true;
//     } else if (msg.includes('退票')) {
//       if (
//         msg.includes('同行人客票在不同渠道购买，请分开提交退票申请') ||
//         msg.includes('系统操作权限') ||
//         msg.includes('客票状态不一致，可分别提交') ||
//         msg.includes(
//           '所有未使用航段必须全退，目前您未使用的航段存在状态不符情况无法提交'
//         ) ||
//         (msg.includes('自助') &&
//           (msg.includes('无法') || msg.includes('不支持'))) ||
//         msg.includes('不支持单独') ||
//         msg.includes('选择以下任一方式')
//       ) {
//         needMod = true;
//       }
//     }
//   }
//   if (needMod) {
//     if (msg.includes('3、联系南航客服95539'))
//       return msg.replace('。', `；<br/>4、${fastRefundSufTitle}`);
//     else if (msg.includes('2、联系南航客服95539'))
//       return msg.replace('。', `；<br/>3、${fastRefundSufTitle}`);
//     else return msg.replace('。', `或者${fastRefundSufTitle}`);
//   }
//   return msg || '';
// }

let popupQueue = [];

function handleClickCallPhone(phone) {
  return function() {
    isCsairApp() ? appTell(phone) : (window.location.href = `tel://${phone}`);
  };
}

function getURLParams(url) {
  const reg = /(\w+)=(\w+)/g;
  const params = {};
  url.replace(reg, function(_, key, value) {
    params[key] = value;
  });
  return params;
}

function handleClickToService(txt, title) {
  let type = session('scopeType');
  let tiNo = session('allTicketNo');
  let allName = session('allName');
  let changeTap = session('changeTap');
  let pageButtonName = session('pageButtonName');
  window.$sensors.sensors.track('popup_click', {
    page_name: getPageName(window.location.hash),
    // popup_area: getPageName(window.location.hash) + pageButtonName ? pageButtonName : '',
    popup_area:
      getPageName(location.hash) + (pageButtonName ? pageButtonName : ''),
    popup_type: '功能弹窗',
    tab_type:
      getPageName(window.location.hash) === '机票退改列表页'
        ? changeTap
          ? changeTap
          : '可退改'
        : getPageName(window.location.hash) === '机票退改-退改说明页'
        ? changeTap
          ? changeTap
          : '退票说明'
        : getPageName(window.location.hash) === '机票退改-取消行程列表页'
        ? changeTap
          ? changeTap
          : '可取消'
        : '',
    popup_title: title,
    popup_content: txt,
    click_type: '我要反馈',
    channel_id: window.location.href
      ? getURLParams(window.location.href).channel
      : '',
    ticket_number: tiNo ? tiNo.replace(/,/g, ';') : '',
    target_url: `https://icc.csair.com/mCustService/#/demands?channel=PC/APP&${
      type ? `type=${type}&` : ''
    }${tiNo ? `ticketNo=${tiNo}` : ''}&prompt=${txt}&${
      allName ? `name=${allName}` : ''
    }`,
  });

  return function() {
    // window.location.href = `https://icc.csair.com/mCustService/#/demands?channel=PC/APP&t${
    //   type ? `type=${type}&` : ''
    // }${tiNo ? `ticketNo=${tiNo}` : ''}&prompt=${txt}&${allName ? `name=${allName}` : ''}`;
    //测试
    window.location.href = `https://icc.csair.com/mCustService/#/demands?channel=PC/APP&${
      type ? `type=${type}&` : ''
    }${tiNo ? `ticketNo=${tiNo}` : ''}&prompt=${txt}&${
      allName ? `name=${allName}` : ''
    }`;
  };
}

function handleClickToArit(txt, title) {
  let type = session('scopeType');
  let tiNo = session('allTicketNo');
  let reCalc = session('reCalc');
  let pageButtonName = session('pageButtonName');
  let changeTap = session('changeTap');
  window.$sensors.sensors.track('popup_click', {
    page_name: getPageName(window.location.hash),
    // popup_area: getPageName(window.location.hash) + pageButtonName ? pageButtonName : '',
    popup_area:
      getPageName(location.hash) + (pageButtonName ? pageButtonName : ''),
    popup_type: '功能弹窗',
    popup_title: title,
    popup_content: txt,
    click_type: '在线人工客服',
    ticket_number: tiNo ? tiNo.replace(/,/g, ';') : '',
    channel_id: window.location.href
      ? getURLParams(window.location.href).channel
      : '',
    tab_type:
      getPageName(window.location.hash) === '机票退改列表页'
        ? changeTap
          ? changeTap
          : '可退改'
        : getPageName(window.location.hash) === '机票退改-退改说明页'
        ? changeTap
          ? changeTap
          : '退票说明'
        : getPageName(window.location.hash) === '机票退改-取消行程列表页'
        ? changeTap
          ? changeTap
          : '可取消'
        : '',
    target_url: '',
  });

  return async function() {
    const res = await client.createHttp('post', '/EMP/customerServiceTickets', {
      data: {
        ticketNo: tiNo.replace(',', ';'),
        typeCode: type,
        speech: txt,
        reCalc: reCalc === '1' ? true : false,
      },
    });
    if (res) {
      window.$sensors.sensors.track('popup_click', {
        page_name: getPageName(window.location.hash),
        // popup_area: getPageName(window.location.hash) + pageButtonName ? pageButtonName : '',
        popup_area:
          getPageName(location.hash) + (pageButtonName ? pageButtonName : ''),
        popup_type: '功能弹窗',
        popup_title: title,
        popup_content: txt,
        click_type: '在线人工客服',
        ticket_number: tiNo ? tiNo.replace(/,/g, ';') : '',
        channel_id: window.location.href
          ? getURLParams(window.location.href).channel
          : '',
        tab_type:
          getPageName(window.location.hash) === '机票退改列表页'
            ? changeTap
              ? changeTap
              : '可退改'
            : getPageName(window.location.hash) === '机票退改-退改说明页'
            ? changeTap
              ? changeTap
              : '退票说明'
            : getPageName(window.location.hash) === '机票退改-取消行程列表页'
            ? changeTap
              ? changeTap
              : '可取消'
            : '',
        target_url: `https://icc.csair.com/mCustService/#/?channel=touch_02&query=dxxzrg&value1=${
          res.data.url
        }`,
      });
      window.location.href = `https://icc.csair.com/mCustService/#/?channel=touch_02&query=dxxzrg&value1=${
        res.data.url
      }`;
    }
  };
}

function handleClickToIng(txt, title) {
  let urlA = '';
  if (webEntry() === 0) {
    urlA = urlConfig.online_service_app_url;
  } else if (webEntry() === 1) {
    urlA = urlConfig.online_service_web_url;
  } else if (webEntry() === 2) {
    urlA = urlConfig.online_service_wx_url;
  }
  let pageButtonName = session('pageButtonName');
  let tiNo = session('allTicketNo');
  let changeTap = session('changeTap');

  window.$sensors.sensors.track('popup_click', {
    page_name: getPageName(window.location.hash),
    // popup_area: getPageName(window.location.hash) + pageButtonName ? pageButtonName : '',
    popup_area:
      getPageName(location.hash) + (pageButtonName ? pageButtonName : ''),
    popup_type: '功能弹窗',
    popup_title: title,
    popup_content: txt,
    click_type: '在线客服',
    channel_id: window.location.href
      ? getURLParams(window.location.href).channel
      : '',

    tab_type:
      getPageName(window.location.hash) === '机票退改列表页'
        ? changeTap
          ? changeTap
          : '可退改'
        : getPageName(window.location.hash) === '机票退改-退改说明页'
        ? changeTap
          ? changeTap
          : '退票说明'
        : getPageName(window.location.hash) === '机票退改-取消行程列表页'
        ? changeTap
          ? changeTap
          : '可取消'
        : '',
    ticket_number: tiNo ? tiNo.replace(/,/g, ';') : '',
    target_url: urlA,
  });
  return function() {
    if (webEntry() === 0) {
      window.location.href = urlConfig.online_service_app_url;
    } else if (webEntry() === 1) {
      window.location.href = urlConfig.online_service_web_url;
    } else if (webEntry() === 2) {
      window.location.href = urlConfig.online_service_wx_url;
    }
  };
}
function TicPopUp({
  title,
  imgICon,
  text,
  onClose,
  btn,
  imgWidth,
  textStyle,
  needTel = true,
  contertStyle,
}) {
  const tel = /(4008895539|95539)/.exec(text);
  let lang = cn;
  // let isEN = window.sessionStorage.getItem('language') == "en";
  let isEN = session('language') == 'en';

  if (isEN) {
    lang = en;
  }
  if (window.sessionStorage.getItem('persist:emp')) {
    lang = JSON.parse(
      JSON.parse(window.sessionStorage.getItem('persist:emp')).App
    ).lang;
  }
  const ser = text.includes('我要反馈');
  const ati = text.includes('在线人工客服');
  const igs = text.includes('【在线客服】');

  const bt = [];
  if (tel && needTel) {
    bt.push({
      text: (
        <a
          href="javascript:void(0)"
          onClick={handleClickCallPhone(tel[0])}
          style={{ color: 'rgba(38, 38, 38, 0.6)' }}
        >
          {lang.contact}
          {tel[0]}
        </a>
      ),
      callback: () => {},
    });
  }
  // GN: [ID1556600][2024-10-16]
  if (ser) {
    if (btn.length !== 0 && btn[0] && btn[0].text.includes(lang.selectDate1)) {
      btn[1] = {
        text: (
          <a
            href="javascript:void(0)"
            onClick={handleClickToService(text, title)}
            style={{ color: 'rgb(0, 138, 203)' }}
            id="iBlack"
            aria-hidden="true"
          >
            我要反馈
          </a>
        ),
        callback: () => {},
      };
      bt.push(...btn);
    } else {
      bt.push(
        {
          text: lang.refCupon3354,
          callback: () => onClose(lang.refCupon3354),
          style: { color: 'rgba(38, 38, 38, 0.6)' },
        },
        {
          text: (
            <a
              href="javascript:void(0)"
              onClick={handleClickToService(text, title)}
              style={{ color: 'rgb(0, 138, 203)' }}
              id="iBlack"
              aria-hidden="true"
            >
              我要反馈
            </a>
          ),
          callback: () => {},
        }
      );
    }
  }

  if (ati) {
    if (btn.length !== 0 && btn[0] && btn[0].text.includes(lang.selectDate1)) {
      btn[1] = {
        text: (
          <a
            href="javascript:void(0)"
            onClick={handleClickToArit(text, title)}
            style={{ color: 'rgb(0, 138, 203)' }}
            id="lineBlack"
            aria-hidden="true"
          >
            在线人工客服
          </a>
        ),
        callback: () => {},
      };
      bt.push(...btn);
    } else {
      bt.push(
        {
          text: lang.refCupon3354,
          callback: () => onClose(lang.refCupon3354),
          style: { color: 'rgba(38, 38, 38, 0.6)' },
        },
        {
          text: (
            <a
              href="javascript:void(0)"
              onClick={handleClickToArit(text)}
              style={{ color: 'rgb(0, 138, 203)' }}
              id="lineBlack"
              aria-hidden="true"
            >
              在线人工客服
            </a>
          ),
          callback: () => {},
        }
      );
    }
  }

  if (igs) {
    bt.push(
      {
        text: '返回',
        callback: () => onClose('返回'),
        style: { color: 'rgba(38, 38, 38, 0.6)' },
      },
      {
        text: (
          <a
            href="javascript:void(0)"
            onClick={handleClickToIng(text, title)}
            style={{ color: 'rgb(0, 138, 203)' }}
            id="lineBlack"
            aria-hidden="true"
          >
            在线客服
          </a>
        ),
        callback: () => {},
      }
    );
  }

  if (!(ser || ati || igs)) {
    btn.length !== 0
      ? bt.push(...btn)
      : bt.push({ text: lang.confirm, callback: () => onClose(lang.confirm) });
  }

  return (
    <div className="popUP_main">
      <div
        id="pCt"
        className="popUP_Content"
        role="dialog"
        tabIndex="-1"
        aria-modal="true"
        style={contertStyle}
      >
        <div className="popUP_close_div">
          <span
            className="popUP_close"
            onClick={() => onClose()}
            aria-label="关闭"
            role="button"
          >
            <Icon type="cross" style={{}} />
          </span>
        </div>
        {title && <p className="popUP_title">{title}</p>}
        <div className="popUP_scrollDiv">
          {imgICon && (
            <div className="popUP_centerImgDiv" style={{ width: imgWidth }}>
              <img className="popUP_centerImg" src={imgICon} alt="" />
            </div>
          )}
          {text && (
            <p
              className="popUP_tip"
              style={textStyle}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
        </div>
        <div className="popUP_btn">
          {bt.map((item, i) => {
            if (item.style) {
              delete item.style.background;
              delete item.style.color;
            }
            return (
              item !== '' && (
                <div
                  key={i}
                  {...(item.style ? { style: item.style } : {})}
                  className={`popUP_submit ${bt.length > 1 ? 'hw' : ''}`}
                  role="button"
                  onClick={item.callback}
                  aria-labelledby={
                    i === 0 ? 'blackB' : 'iBlack lineBlack blackB2'
                  }
                >
                  <p
                    style={{
                      borderLeft: bt.length > 1 ? '1px solid #ccc' : 'none',
                      width: '100%',
                      color:
                        item.text === lang.close || item.text === lang.Cancel
                          ? 'rgba(38, 38, 38, 0.6)'
                          : 'rgba(0, 138, 203, 1)',
                    }}
                  >
                    <span
                      id={i === 0 ? 'blackB' : 'blackB2'}
                      aria-hidden="true"
                    >
                      {item.text}
                    </span>
                  </p>
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
}

TicPopUp.defaultProps = {
  onClose: () => {},
  title: '',
  imgICon: '',
  imgWidth: '2.5rem',
  text: '',
  btn: [],
  textStyle: {},
  contertStyle: {},
};

/**
 * 弹框
 * @param { title, text, onClose, imgICon, actions, imgWidth, textStyle,contertStyle }
 * desc
 * onClose fn
 * actions array (item => { text: '', onPress: fn })
 */
export default function Popup(...args) {
  const title = args[0];
  const content = args[1];
  const onClose = args[2] || function() {};
  const imgICon = args[3];
  const actions = args[4] || [];
  const imgWidth = args[5];
  const textStyle = args[6];
  const needTel = args[7];
  const contertStyle = args[8];

  if (!title && !content) {
    return {
      close: () => {},
    };
  }

  let div = document.createElement('div');
  document.body.appendChild(div);

  let timeoutEvn = null;
  function keydownFun(e) {
    let dom = document.getElementById('pCt');
    const focusableElements = dom.getElementsByTagName('*');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];
    let isTabPressed =
      e.key === 'Tab' || (e.shiftKey && e.key === 'Tab') || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // 如果Shift键被按下，向回切换焦点
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向后切换行为
      }
    } else {
      // 否则向前切换焦点
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向前切换行为
      }
    }
  }
  function close(text) {
    let pageButtonName = session('pageButtonName');
    let tiNo = session('allTicketNo');
    let changeTap = session('changeTap');

    // JSON.parse(JSON.parse(window.sessionStorage.getItem('persist:emp')).updateDetail).selectStyle==="1"
    window.$sensors.sensors.track('popup_click', {
      page_name: getPageName(location.hash),
      popup_area:
        getPageName(location.hash) + (pageButtonName ? pageButtonName : ''),
      popup_type: '功能弹窗',
      popup_title: title,
      popup_content: content,
      click_type: text,
      channel_id: window.location.href
        ? getURLParams(window.location.href).channel
        : '',

      ticket_number: tiNo ? tiNo.replace(/,/g, ';') : '',
      target_url: '',
      tab_type:
        getPageName(location.hash) === '机票退改列表页'
          ? changeTap
            ? changeTap
            : '可退改'
          : getPageName(location.hash) === '机票退改-退改说明页'
          ? changeTap
            ? changeTap
            : '退票说明'
          : getPageName(location.hash) === '机票退改-取消行程列表页'
          ? changeTap
            ? changeTap
            : '可取消'
          : '',
    });
    if (!div) return;
    clearTimeout(timeoutEvn);
    document.removeEventListener('keydown', keydownFun);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    ReactDOM.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    div = null;
  }

  const footer = actions.map(button => {
    const orginPress = button.onPress || function() {};
    let pageButtonName = session('pageButtonName');
    let changeTap = session('changeTap');

    button.callback = () => {
      const res = orginPress();
      if (res && res.then) {
        window.$sensors.sensors.track('popup_click', {
          page_name: getPageName(location.hash),
          popup_area:
            getPageName(location.hash) + (pageButtonName ? pageButtonName : ''),
          popup_type: '功能弹窗',
          popup_title: title,
          popup_content: content,
          click_type: button.text,
          target_url: '',
          channel_id: window.location.href
            ? getURLParams(window.location.href).channel
            : '',
          tab_type:
            getPageName(location.hash) === '机票退改列表页'
              ? changeTap
                ? changeTap
                : '可退改'
              : getPageName(location.hash) === '机票退改-退改说明页'
              ? changeTap
                ? changeTap
                : '退票说明'
              : getPageName(location.hash) === '机票退改-取消行程列表页'
              ? changeTap
                ? changeTap
                : '可取消'
              : '',
        });
        res.then(() => {
          window.$sensors.sensors.track('popup_click', {
            page_name: getPageName(location.hash),
            // popup_area: getPageName(location.hash) + pageButtonName ? pageButtonName : '',
            popup_area:
              getPageName(location.hash) +
              (pageButtonName ? pageButtonName : ''),
            popup_type: '功能弹窗',
            popup_title: title,
            popup_content: content,
            click_type: button.text,
            target_url: '',
            channel_id: window.location.href
              ? getURLParams(window.location.href).channel
              : '',
            tab_type:
              getPageName(location.hash) === '机票退改列表页'
                ? changeTap
                  ? changeTap
                  : '可退改'
                : getPageName(location.hash) === '机票退改-退改说明页'
                ? changeTap
                  ? changeTap
                  : '退票说明'
                : getPageName(location.hash) === '机票退改-取消行程列表页'
                ? changeTap
                  ? changeTap
                  : '可取消'
                : '',
          });
          close(button.text);
        });
      } else {
        window.$sensors.sensors.track('popup_click', {
          page_name: getPageName(location.hash),
          popup_area:
            getPageName(location.hash) + (pageButtonName ? pageButtonName : ''),
          popup_type: '功能弹窗',
          popup_title: title,
          popup_content: content,
          click_type: button.text,
          target_url: '',
          channel_id: window.location.href
            ? getURLParams(window.location.href).channel
            : '',
          tab_type:
            getPageName(location.hash) === '机票退改列表页'
              ? changeTap
                ? changeTap
                : '可退改'
              : getPageName(location.hash) === '机票退改-退改说明页'
              ? changeTap
                ? changeTap
                : '退票说明'
              : getPageName(location.hash) === '机票退改-取消行程列表页'
              ? changeTap
                ? changeTap
                : '可取消'
              : '',
        });
        close(button.text);
      }
    };
    return button;
  });

  ReactDOM.render(
    <TicPopUp
      title={title}
      imgICon={imgICon}
      imgWidth={imgWidth}
      textStyle={textStyle}
      onClose={text => {
        onClose();
        close(text);
      }}
      text={content}
      btn={footer}
      needTel={needTel}
      contertStyle={contertStyle}
    />,
    div
  );

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('pCt').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  function trapFocus() {
    document.addEventListener('keydown', keydownFun);
  }
  timeoutEvn = setTimeout(() => {
    focus();
    trapFocus();
  }, 200);
  popupQueue.push({
    close,
  });

  return popupQueue[popupQueue.length - 1];
}

Popup.clear = () => {
  if (popupQueue && popupQueue.length) {
    popupQueue.forEach(progess => {
      progess.close();
    });
    popupQueue = [];
  }
};



// WEBPACK FOOTER //
// ./src/components/PopUp/index.js